// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Modal = t.struct({
    id: t.maybe(t.String),
    isVisible: t.Boolean
}, 'Modal');

export const getDefaultState = () =>
    new Modal({
        isVisible: false
    });

export default Modal;



// WEBPACK FOOTER //
// ./src/product/shared/state/modal.js